import React from "react";
import styles from "./ProfilePage.module.scss";
import { useSelector } from "react-redux";
import StatusComponent from "../../components/StatusComponent/StatusComponent";
import {
  selectIsAdmin,
  selectIsPharmacist,
  selectIsDriver,
  selectIsMarketplaceAdmin,
} from "../../store/auth-slice";

const ProfilePage: React.FC = () => {
  const isAdminState = useSelector(selectIsAdmin);
  const isPharmacistState = useSelector(selectIsPharmacist);
  const isDriverState = useSelector(selectIsDriver);
  const isMarketplaceAdmin = useSelector(selectIsMarketplaceAdmin);

  return (
    <div className={styles.ProfilePage}>
      <StatusComponent
        isAdmin={isAdminState}
        isMarketplaceAdmin={isMarketplaceAdmin}
        isPharmacist={isPharmacistState}
        isDriver={isDriverState}
      />
    </div>
  );
};

export default ProfilePage;
